var map = {
	"./arrow-down.png": 489,
	"./arrow-left.png": 490,
	"./doctor-profile-default.png": 491,
	"./ic-attachment.png": 492,
	"./ic-close.png": 493,
	"./ic-doctor.png": 494,
	"./ic-file.png": 495,
	"./ic-hang-up-2.png": 496,
	"./ic-hang-up.png": 497,
	"./ic-mic-disabled.png": 498,
	"./ic-mic.png": 499,
	"./ic-more.png": 500,
	"./ic-phone.png": 501,
	"./ic-send.png": 502,
	"./ic-specialist.png": 503,
	"./ic-switch-camera.png": 504,
	"./ic-video-call-purple.png": 505,
	"./ic-video-camera-2.png": 506,
	"./ic-video-camera-disabled.png": 507,
	"./ic-video-camera.png": 508,
	"./ic-video.png": 509,
	"./img-placeholder.png": 510,
	"./logo-gradient.png": 511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 488;